import { create } from 'zustand'

interface OrganizationStats {
  summary: {
    机构名称: string
    相关标准总数: number
  }
  roles_distribution: Array<{
    机构角色: string
    标准数量: number
  }>
  type_distribution: Array<{
    标准类别: string
    参与数量: number
  }>
  yearly_trend: Array<{
    发布年份: number
    年度发布数量: number
  }>
  co_drafting_partners: Array<{
    合作机构: string
    共同起草数量: number
  }>
  classification_distribution: Array<{
    分类号: string
    数量: number
  }>
}

interface PersonStats {
  person_name: string
  message: string
  stats: Record<string, any>
}

interface StatsStore {
  organizationStats: OrganizationStats | null
  loading: boolean
  error: string | null
  
  // Actions
  fetchOrganizationStats: (orgName: string) => Promise<void>
  clearStats: () => void
  setError: (error: string | null) => void
}

// 使用相对路径，通过 nginx 代理到后端
const API_BASE_URL = '/api'

export const useStatsStore = create<StatsStore>((set, get) => ({
  organizationStats: null,
  loading: false,
  error: null,

  fetchOrganizationStats: async (orgName: string) => {
    set({ loading: true, error: null })
    try {
      const encodedName = encodeURIComponent(orgName)
      const response = await fetch(`${API_BASE_URL}/stats/organizations/${encodedName}`)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const data = await response.json()
      set({ organizationStats: data.data, loading: false })
    } catch (error) {
      console.error('获取机构统计失败:', error)
      set({ 
        error: error instanceof Error ? error.message : '获取机构统计失败',
        loading: false 
      })
    }
  },

  clearStats: () => {
    set({ organizationStats: null })
  },

  setError: (error: string | null) => {
    set({ error })
  }
}))